<template>
  <div class="all">
    <EnrollList ref="enrollList" type="join" />
    <!-- <div class="tip">以上为出题人要求填写的信息，如有疑问可联系出题人。</div> -->
    <div class="save-btn">
      <div :style="{ background: theme_color, borderColor: theme_color }" @click="enrollData">完成，继续答题</div>
    </div>
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import { Toast, Dialog } from "vant";
import { getToken, reLogin } from "@/utils/common";
import EnrollList from "@/components/elist";
import { throttle } from "lodash";

export default {
  components: { EnrollList },
  data() {
    return {
      qid: "",
      unionid: "",
      theme_color: "#1890FF"
    };
  },
  mounted() {
    this.qid = this.$route.query.qid;
    this.unionid = this.$route.query.unionid;
    this.theme_color = this.$route.query.theme_color || '#1890FF';
  },
  methods: {
    enrollData: throttle(
      function() {
        this.$refs.enrollList.enrollData();
      },
      2000,
      { trailing: false }
    ),
    // enrollData() {
    //   this.$refs.enrollList.enrollData()
    // },
    enroll(info) {
      let param = {
        qid: this.qid,
        unionid: this.unionid,
        access_token: getToken(),
        reg_params: info
      };
      questionOnly.post("/xcx/ques/v2/reginfo", param).then(res => {
        if (res.sta == 0) {
          Dialog.confirm({
            title: "温馨提示",
            message: "信息保存成功，是否现在立即开始答题",
            confirmButtonColor: '#1890ff'
          })
            .then(() => {
              var hasNameItem = info.find((item)=> item.field_key == 1)
              if(hasNameItem) {
                let preInfo = JSON.parse(localStorage.getItem('info'));
                localStorage.setItem('info', JSON.stringify({...preInfo, join_name: hasNameItem.field_value}))
              }
              this.quesStart();
            })
            .catch(() => {
              this.$router.replace({
                name: "normalDetail",
                query: { qid: this.qid }
              });
            });
        } else if (res.sta === -500) {
          reLogin();
        } else if (
          res.sta == -1 &&
          (res.errcode == 110 || res.errcode == 113 || res.errcode == 118)
        ) {
          // 达到答题人数限制
          this.pause(res.errcode == 118 ? 5 : 2);
          // if(res.errcode == 110) {
          //   Dialog.confirm({
          //     title: '温馨提示',
          //     message: '答题人数已达到上限，如需参与答题，请修改【限制答题人数】',
          //     confirmButtonText: '前往修改',
          //     confirmButtonColor: '#1890ff',
          //     cancelButtonText: '我知道了',
          //     cancelButtonColor: '#262626'
          //   }).then(()=>{
          //      this.$router.push({name: 'helpCenter', query: {qid: this.qid}})
          //   })
          // }else {
          //   this.pause(2)
          // }
        } else {
          Toast(res.msg);
        }
      });
    },
    quesStart() {
      questionOnly
        .post("/xcx/ques/v2/start", {
          access_token: getToken(),
          qid: this.qid,
          version_code: 1
        })
        .then(res => {
          if (res.sta == 0) {
            // 跳转答题 =>
            localStorage.setItem("start_time_" + this.qid, res.data.now);
            this.$router.replace({
              name: "doNormal",
              query: { qid: this.qid }
            });
          } else if (res.sta === -500) {
            this.handleErr("/normal/detail?qid=" + this.qid);
          } else if (
            res.sta == -1 &&
            (res.errcode == 110 ||
              res.errcode == 113 ||
              res.errcode == 115 ||
              res.errcode == 118)
          ) {
            // 达到答题人数上限
            let { errcode } = res;
            let { wait_status = 0 } = res.data || {}; // wait_status 0:排队人数没超过50, 1: 排队人数超出50
            let pauseType = errcode == 115 ? 4 : errcode == 118 ? 5 : 2;
            this.pause(pauseType, wait_status);
          } else {
            Toast(res.msg);
          }
        })
        .catch(() => {});
    },
    pause(type, wait_status) {
      let query = { type, qid: this.qid };
      if (wait_status) query.wait_status = 1;
      this.$router.replace({ name: "detailPause", query: query });
    }
  }
};
</script>

<style scoped lang="scss">
.all {
  background-color: #ffffff;
  min-height: 100vh;
  min-width: 320px;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  .tip {
    font-size: 13px;
    color: #999;
    padding: 0;
    margin: 10px 0;
  }
  .save-btn {
    margin: 20px 15px 0;
    div {
      height: 45px;
      line-height: 45px;
      border-radius: 5px;
      color: #ffffff;
      text-align: center;
      font-size: 18px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/enroll/enroll.vue